import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Historia.css';
import './MobileNav.css';
import logo from '../assets/logoblanco-def.png';
import favicon from '../assets/favicon.png';
import { useCart } from '../context/CartContext';
import { useNavbarScroll } from '../hooks/useNavbarScroll';
import MobileNav from './MobileNav';
import winecurv01 from '../assets/winecurv_15_1-Convertido-01.png';
import winecurv02 from '../assets/winecurv_15_1-Convertido-02.png';
import winecurv04 from '../assets/winecurv_15_1-Convertido-04.png';
import winecurv05 from '../assets/winecurv_15_1-Convertido-05.png';
import winecurv06 from '../assets/winecurv_15_1-Convertido-06.png';
import winecurv14 from '../assets/winecurv_15_1-Convertido-14.png';
import winecurv17 from '../assets/winecurv_15_1-Convertido-17.png';
import winecurv18 from '../assets/winecurv_15_1-Convertido-18.png';
import winecurv22 from '../assets/winecurv_15_1-Convertido-22.png';
import winecurv24 from '../assets/winecurv_15_1-Convertido-24.png';
import winecurv25 from '../assets/winecurv_15_1-Convertido-25.png';
import winecurv27 from '../assets/winecurv_15_1-Convertido-27.png';

const GrapeIcon = () => (
  <svg className="timeline-grape-icon" viewBox="0 0 40 50" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path d="M20 8 Q12 18 20 28 Q28 18 20 8" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.7"/>
    <circle cx="14" cy="22" r="5" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.8"/>
    <circle cx="26" cy="22" r="5" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.8"/>
    <circle cx="20" cy="32" r="5" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.8"/>
    <path d="M20 38 L20 48" stroke="currentColor" strokeWidth="1.5" opacity="0.7"/>
  </svg>
);

const timeline1977Imgs = [
  require('../assets/1977.jpg'),
  require('../assets/1977-2.jpg'),
];

const TIMELINE_ENTRIES = [
  { year: 1978, subtitle: 'ADQUISICIÓN DEL PRIMER CAMIÓN: FORD THAMES', side: 'left', images: [require('../assets/1978.jpg')] },
  { year: 1991, subtitle: 'CONSTRUCCIÓN DE LA NUEVA BODEGA EN SAUCE', side: 'right', images: [require('../assets/1991.jpg'), require('../assets/1991-2.jpg'), require('../assets/1991-3.jpg')] },
  { year: 1995, subtitle: 'COMPRA DE UNA VIEJA BODEGA EN CANELÓN CHICO. EN LA ACTUALIDAD EN ESTE ESTABLEIMIENTO SE REALIZA LA VENDIMIA', side: 'left', images: [require('../assets/1995.jpg'), require('../assets/1995-2.jpg')] },
  { year: 1999, subtitle: 'Se comienza a envasar el vino en cajas de tetra, lo que luego de muchos años significó un aumento considerable en las ventas.', side: 'right', images: [require('../assets/1999.jpg')] },
  { year: 2004, subtitle: 'Se adquiere un campo en Cuchilla de Rocha, que en la actualidad tiene más de 100 hectáreas de viñas. Esta compra implicó un crecimiento sustancial en la producción de uva.', side: 'left', images: [require('../assets/2004.jpg'), require('../assets/2004-2.jpg')] },
  { year: 2007, subtitle: 'Se lanza al mercado el jugo de uva sin alcohol. La bodega fue una de las primeras en el país en elaborarlo.', side: 'right', images: [require('../assets/2007.jpg')] },
  { year: 2011, subtitle: 'Se lanza al mercado la primera línea de vinos finos Don Jacinto, en honor a uno de los fundadores, con el que se han obtenido diversos reconocimientos a nivel nacional e Internacional.', side: 'left', images: [require('../assets/2011.jpeg'), require('../assets/2011-2.jpg')] },
  { year: 2016, subtitle: 'Compra y colocación de una gran cantidad de tanques, que permitió ampliar la capacidad de almacenaje.', side: 'right', images: [require('../assets/2016.jpg'), require('../assets/2016-2.jpeg'), require('../assets/2016-3.jpeg')] },
  { year: 2021, subtitle: 'Lanzamiento en Movie de una pieza publicitaria, con una campaña 360º que generó un gran impacto a nivel nacional.', side: 'left', images: [require('../assets/2021.jpg')] },
  { year: 2023, subtitle: 'Filmación de campaña publicitaria en Argentina. El rodaje duró tres días y fue un gran desafío lograrlo.', side: 'right', images: [require('../assets/2023.jpg'), require('../assets/2023-2.jpg'), require('../assets/2023-3.jpg')] }
];

const initialVisible = TIMELINE_ENTRIES.reduce((acc, { year }) => ({ ...acc, [year]: false }), { 1977: false });

const Historia = () => {
  const navigate = useNavigate();
  const { toggleCart, getTotalItems } = useCart();
  const timeline1977Ref = useRef(null);
  const timelineTrackRef = useRef(null);
  const [navReady, setNavReady] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [timelineVisible, setTimelineVisible] = useState(initialVisible);
  const { hidden: navbarHidden, compact: navbarCompact } = useNavbarScroll();

  useEffect(() => {
    window.scrollTo(0, 0);
    const timer = setTimeout(() => setNavReady(true), 100);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const year = entry.target.getAttribute('data-year');
        if (year && entry.isIntersecting) setTimelineVisible((v) => ({ ...v, [year]: true }));
      });
    }, { threshold: 0.15 });
    if (timeline1977Ref.current) obs.observe(timeline1977Ref.current);
    const track = timelineTrackRef.current;
    if (track) {
      track.querySelectorAll('[data-year]').forEach((el) => obs.observe(el));
    }
    return () => obs.disconnect();
  }, []);

  return (
    <section className="historia-section" id="historia">
      {/* Siluetas winecurv flotantes */}
      <img src={winecurv01} alt="" className="historia-wine-decor historia-wine-decor-1" />
      <img src={winecurv02} alt="" className="historia-wine-decor historia-wine-decor-2" />
      <img src={winecurv06} alt="" className="historia-wine-decor historia-wine-decor-3" />
      <img src={winecurv18} alt="" className="historia-wine-decor historia-wine-decor-4" />
      <img src={winecurv22} alt="" className="historia-wine-decor historia-wine-decor-5" />
      <img src={winecurv25} alt="" className="historia-wine-decor historia-wine-decor-6" />
      <img src={winecurv04} alt="" className="historia-wine-decor historia-wine-decor-7" />
      <img src={winecurv17} alt="" className="historia-wine-decor historia-wine-decor-8" />
      <img src={winecurv24} alt="" className="historia-wine-decor historia-wine-decor-9" />
      <img src={winecurv05} alt="" className="historia-wine-decor historia-wine-decor-10" />
      <img src={winecurv14} alt="" className="historia-wine-decor historia-wine-decor-11" />
      <img src={winecurv27} alt="" className="historia-wine-decor historia-wine-decor-12" />

      {/* Navigation */}
      <nav className={`historia-navbar${navReady ? ' historia-nav-ready' : ''}${navbarHidden ? ' navbar-hidden' : ''}${navbarCompact ? ' navbar-compact' : ''}`}>
        <div className="historia-navbar-content">
          <div className="navbar-left-historia">
            <button onClick={() => navigate('/')} className="nav-link-historia">INICIO</button>
            <button onClick={() => navigate('/equipo')} className="nav-link-historia">EQUIPO</button>
            <button onClick={() => navigate('/bodegas')} className="nav-link-historia">BODEGAS</button>
          </div>
          <div className="navbar-center-historia">
            <button onClick={() => navigate('/')}>
              <img src={logo} alt="Rosés Wines" className="nav-logo-historia" />
            </button>
          </div>
          <div className="navbar-right-historia">
            <button onClick={() => navigate('/historia')} className="nav-link-historia">HISTORIA</button>
            <button onClick={() => navigate('/kit-de-marca')} className="nav-link-historia">KIT DE MARCA</button>
            <button onClick={() => navigate('/#tienda')} className="nav-link-historia">TIENDA</button>
            <button className="nav-link-historia cart-historia" onClick={toggleCart}>
              <span className="cart-icon">🛒</span>
              {getTotalItems() > 0 && (
                <span className="cart-badge-historia">{getTotalItems()}</span>
              )}
            </button>
          </div>
          <button
            type="button"
            className={`mobile-nav-hamburger${mobileMenuOpen ? ' open' : ''}`}
            onClick={() => setMobileMenuOpen((o) => !o)}
            aria-expanded={mobileMenuOpen}
            aria-label="Menú"
          >
            <span className="mobile-nav-hamburger-line" />
            <span className="mobile-nav-hamburger-line" />
            <span className="mobile-nav-hamburger-line" />
          </button>
        </div>
      </nav>

      <MobileNav open={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} />

      <div className="container">
        {/* Hero Nuestra Historia */}
        <div className="historia-hero text-center">
          <div className="historia-vine-wrap" aria-hidden>
            <img src={favicon} alt="Rosés Wines" className="historia-favicon" />
          </div>
          <h2 className="historia-hero-title">NUESTRA<br />HISTORIA</h2>
          <p className="historia-hero-intro">
            En 1977 nace la historia de Bodega Rosés, gracias al matrimonio de Jacinto y Melva, quienes con esfuerzo compraron una vieja bodega, ubicada en la Ruta 6 km 30.200, que tenía un viñedo de más de 50 años.
          </p>
          <button className="scroll-indicator-historia" onClick={() => {
            const timeline = document.querySelector('.timeline');
            timeline?.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }} aria-label="Bajar a la línea de tiempo">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 5v14M19 12l-7 7-7-7" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>

        {/* Timeline */}
        <div className="timeline">
          <div ref={timeline1977Ref} className={`timeline-item timeline-item--1977 ${timelineVisible[1977] ? 'timeline-visible' : ''}`} data-year="1977">
            <div className="timeline-year">1977</div>
            <div className="timeline-subtitle-fundacion">FUNDACIÓN DE BODEGA ROSÉS</div>
          </div>

          <div className="timeline-track" ref={timelineTrackRef}>
            <div className="timeline-spine" aria-hidden />
            <div className={`timeline-item timeline-item--1977-photos ${timelineVisible[1977] ? 'timeline-visible' : ''}`}>
            <div className="timeline-photos timeline-photos--triple">
              {timeline1977Imgs.slice(0, 3).map((src, i) => (
                <div key={i} className="timeline-photo-circle" style={{ backgroundImage: `url(${src})` }} />
              ))}
            </div>
          </div>

            {TIMELINE_ENTRIES.map(({ year, subtitle, side, images }) => (
              <div
                key={year}
                className={`timeline-item timeline-item--year timeline-item--${side} ${timelineVisible[year] ? 'timeline-visible' : ''}`}
                data-year={String(year)}
              >
            <div className="timeline-content-left">
                  {side === 'left' ? (
                    <div className="timeline-text-block">
                      <div className="timeline-year">{year}</div>
                      <div className="timeline-subtitle">{subtitle}</div>
                    </div>
                  ) : (
                    <div className={`timeline-rings timeline-rings--${images.length}`}>
                      {images.map((img, i) => (
                        <div key={i} className="timeline-ring" style={{ backgroundImage: `url(${img})`, zIndex: i + 1 }} />
                      ))}
                    </div>
                  )}
            </div>
            <div className="timeline-content-right">
                  {side === 'right' ? (
                    <div className="timeline-text-block">
                      <div className="timeline-year">{year}</div>
                      <div className="timeline-subtitle">{subtitle}</div>
                    </div>
                  ) : (
                    <div className={`timeline-rings timeline-rings--${images.length}`}>
                      {images.map((img, i) => (
                        <div key={i} className="timeline-ring" style={{ backgroundImage: `url(${img})`, zIndex: i + 1 }} />
                      ))}
                    </div>
                  )}
            </div>
                {year === 2023 && (
            <div className="timeline-deco-grape">
              <GrapeIcon />
            </div>
                )}
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default Historia;
